import { map } from 'rxjs/operators'
import { GET, POST } from '../../../module/services/fetch'
import { ContactsType, OtpOperationType } from './constants'

// Generate UIGP OTP
export const generateUigpOtpService = (body: {
  operation: OtpOperationType
  method: ContactsType
  userCode?: string
}) => {
  const { method, operation, userCode } = body
  return GET(
    `authentication/otp?${userCode ? `userCode=${userCode}` : ``}${
      !userCode ? `operation=${operation}` : `&operation=${operation}`
    }&deliveryMethod=${method}`
  ).pipe(map((res: any) => res))
}

export const verifyEmailOtpChangeMobileService = (body: {
  newMobileNumber: string
  otp: string
}) =>
  POST('authentication/validate-chg-mobile-number', body).pipe(
    map((response: any) => response)
  )

// Get security questions
export const getSecurityQuestionsChangeMobileService = () =>
  // probably need to add query params operation=something
  GET(`authentication/question?operation=CHG_MOB_NUM`).pipe(
    map((response: any) => response)
  )

export const verifySecurityQuestionsChangeMobileService = (body: {
  newMobileNumber: string
  answers: { id: string; answer: string }[]
}) =>
  POST('authentication/question/verify/change-mobile-number', body).pipe(
    map((response: any) => response)
  )

// Verify uigp OTP
export const verifyUigpOtpService = (body: {
  operation: OtpOperationType
  otp: string
  userCode?: string
}) => {
  const { operation, otp, userCode } = body
  return POST(
    `authentication/verofy-otp?${userCode ? `userCode=${userCode}` : ''}${
      userCode ? `&operation=${operation}` : `operation=${operation}`
    }`,
    otp
  ).pipe(map((response: any) => response))
}

// CA Mobile Authenticator
export const verifyCaAuthenticatorOtpChangeMobileService = (body: {
  newMobileNumber: string
  otp: string
}) =>
  POST('authentication/changeMobileNumber', body).pipe(
    map((response: any) => response)
  )
